import { jwtService } from "services";
// import { setUserData } from "./user.actions";

export const UPDATE_USER_DATA_START = "[USER] UPDATE_USER_DATA_START";
export const UPDATE_USER_DATA_SUCCESS = "[USER] UPDATE_USER_DATA_SUCCESS";
export const UPDATE_USER_DATA_FAILURE = "[USER] UPDATE_USER_DATA_FAILURE";

export const submitUpdateUser = ({ Cellphone, Phone1, Address, onSuccess }) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_USER_DATA_START,
    });
    jwtService
      .updateUserData({ Cellphone, Phone1, Address })
      .then((user) => {
        // dispatch(setUserData(user));
        onSuccess();
        return dispatch({
          type: UPDATE_USER_DATA_SUCCESS,
        });
      })
      .catch((error) => {
        return dispatch({
          type: UPDATE_USER_DATA_FAILURE,
          payload: error,
        });
      });
  };
};
